/* UNFUNK PDP High-Converting Interactivity */
(function () {
  'use strict';

  /* One shared animation-frame gate for scroll-driven work.

     Scroll handlers that read layout and write styles on every event are the
     cheapest way to make a page feel slow: they compete with the shopper's tap for
     the same frame. Gating them through requestAnimationFrame caps the work at one
     pass per frame and lets the browser service input first. */
  function rafThrottle(fn) {
    var queued = false;
    return function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        fn();
      });
    };
  }

  /* ---- Gallery: one scroll-snap track, driven by thumbs, arrows and swipes ---- */
  document.querySelectorAll('[data-uf-hero]').forEach(function (hero) {
    var track = hero.querySelector('[data-gallery-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(hero.querySelectorAll('[data-gallery-thumb]'));
    var dotsWrap = hero.querySelector('[data-gallery-dots]');
    var dots = [];
    var current = -1;
    var raf = 0;

    /* Dots are the phone's position indicator; CSS hides them above 768px. */
    if (dotsWrap) {
      slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'uf-gallery-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to product image ' + (i + 1));
        dot.addEventListener('click', function () { go(i); });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function paint(i) {
      if (i === current) return;
      current = i;
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        if (k === i) { t.setAttribute('aria-current', 'true'); }
        else { t.removeAttribute('aria-current'); }
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      var active = thumbs[i];
      var box = active && active.parentElement;
      /* Keep the active thumbnail inside its own scroller. Measured with rects
         rather than offsetLeft, which is relative to whichever ancestor happens to
         be positioned - that is not necessarily the thumbnail row. */
      if (box && box.scrollTo) {
        var boxRect = box.getBoundingClientRect();
        var thumbRect = active.getBoundingClientRect();
        box.scrollTo({
          left: box.scrollLeft + (thumbRect.left - boxRect.left) - (boxRect.width - thumbRect.width) / 2,
          behavior: 'smooth'
        });
      }
    }

    function go(i) {
      if (!slides.length) return;
      var n = ((i % slides.length) + slides.length) % slides.length;
      var left = n * track.clientWidth;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (track.scrollTo) { track.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' }); }
      else { track.scrollLeft = left; }
      paint(n);
    }

    /* A swipe, a trackpad gesture or a dot click all land here, so the indicator
       follows the real scroll position instead of a separately-tracked index. */
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = 0;
        var width = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / width);
        if (i < 0) i = 0;
        if (i > slides.length - 1) i = slides.length - 1;
        paint(i);
      });
    }, { passive: true });

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function (e) { e.preventDefault(); go(i); });
    });
    var prev = hero.querySelector('[data-gallery-prev]');
    var next = hero.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    });

    /* Slide width is 100% of the track, so a resize invalidates scrollLeft. */
    window.addEventListener('resize', function () {
      var width = track.clientWidth;
      if (!width || current < 0) return;
      track.scrollLeft = current * width;
    });

    paint(0);
  });

  /* ---- Pack selector & Buy Form ---- */
  document.querySelectorAll('[data-uf-buy-form]').forEach(function (form) {
    var packs = form.querySelectorAll('[data-uf-pack]');
    var cta = form.querySelector('.uf-hero-cta');
    var subscribeCheckbox = form.querySelector('[data-uf-subscribe-checkbox]');
    var sellingPlanHidden = form.querySelector('[data-uf-selling-plan]');
    var ufNote = form.querySelector('[data-uf-subscribe-note]');
    var heroPrice = (form.closest('[data-uf-hero]') || document).querySelector('[data-uf-hero-price]');
    var plan = (subscribeCheckbox && subscribeCheckbox.checked) ? 'subscribe' : 'one-time';
    var buyOnceBtn = form.querySelector('[data-uf-buy-once]');
    var buyOnceLabel = form.querySelector('[data-uf-buy-once-label]');
    var buyOncePrice = form.querySelector('[data-uf-buy-once-price]');

    var bumpCard = form.querySelector('[data-uf-order-bump]');
    var bumpCheckbox = form.querySelector('[data-uf-bump-checkbox]');
    if (bumpCheckbox) {
      bumpCheckbox.addEventListener('change', function () {
        var sel = form.querySelector('[data-uf-pack].is-selected') || packs[0];
        if (sel) select(sel);
      });
    }

    /* Subscription-only arms: Buy once adds the selected pack without a selling plan.
       The visible offer remains subscription-first, exactly as in the client reference. */
    function syncBuyOnceLabel() {
      if (!buyOnceBtn) return;
      /* The loading state owns the button's contents until the navigation lands. */
      if (buyOnceBtn.classList.contains('is-loading')) return;
      var selectedPack = form.querySelector('[data-uf-pack].is-selected') || packs[0];
      if (!selectedPack) return;
      buyOnceBtn.hidden = false;
      var raw = selectedPack.getAttribute('data-base-price');
      var money = formatMoney(parseInt(raw, 10) || 0);
      if (buyOnceLabel) buyOnceLabel.textContent = 'Buy once';
      if (buyOncePrice) buyOncePrice.textContent = money;
      buyOnceBtn.setAttribute('aria-label', 'Buy once — ' + money);
    }

    /* The one-time POST navigates, so the page sits still for a moment after the click.
       Without this the click reads as "nothing happened" and invites a second one. */
    function setBuyOnceLoading() {
      if (!buyOnceBtn || buyOnceBtn.classList.contains('is-loading')) return;
      buyOnceBtn.classList.add('is-loading');
      buyOnceBtn.disabled = true;
      buyOnceBtn.setAttribute('aria-busy', 'true');
      buyOnceBtn.setAttribute('aria-label', 'Taking you to checkout');
      /* Rebuild the contents rather than swapping one span: the label and the price are
         separated by a bare " - " text node that would otherwise be left dangling. */
      buyOnceBtn.textContent = '';
      var spinner = document.createElement('span');
      spinner.className = 'uf-buy-once-spinner';
      spinner.setAttribute('aria-hidden', 'true');
      buyOnceBtn.appendChild(spinner);
      buyOnceBtn.appendChild(document.createTextNode('Taking you to checkout...'));
    }

    if (buyOnceBtn && subscribeCheckbox) {
      buyOnceBtn.addEventListener('click', function () {
        if (buyOnceBtn.classList.contains('is-loading')) return;
        var selectedPack = form.querySelector('[data-uf-pack].is-selected') || packs[0];
        if (!selectedPack) return;
        var selectedRadio = selectedPack.querySelector('input[name="id"]');
        var selectedId = selectedRadio && selectedRadio.value;
        if (!selectedId) return;

        /* Submit a short-lived one-time form: never toggle the visible subscription state. */
        var onceForm = document.createElement('form');
        onceForm.method = 'post';
        onceForm.action = form.action;
        onceForm.style.display = 'none';
        var variantInput = document.createElement('input');
        variantInput.type = 'hidden';
        variantInput.name = 'id';
        variantInput.value = selectedId;
        onceForm.appendChild(variantInput);
        var quantityInput = form.querySelector('input[name="quantity"]');
        if (quantityInput && quantityInput.value) {
          var onceQuantity = document.createElement('input');
          onceQuantity.type = 'hidden';
          onceQuantity.name = 'quantity';
          onceQuantity.value = quantityInput.value;
          onceForm.appendChild(onceQuantity);
        }
        /* Straight to checkout: /cart/add answers 302 -> return_to when present,
           and 302 -> /cart when it is not. Verified against the live store. */
        var returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        returnInput.value = '/checkout';
        onceForm.appendChild(returnInput);
        document.body.appendChild(onceForm);
        setBuyOnceLoading();
        /* Let the spinner paint before the navigation starts, or the DOM change may never
           render. A timer, not requestAnimationFrame: rAF does not fire in a hidden
           document, which would swallow the submit entirely. */
        setTimeout(function () { onceForm.submit(); }, 0);
      });
      /* Pack radio changes bubble after their selection handler, so the amount follows the selected pack. */
      form.addEventListener('change', function () { syncBuyOnceLabel(); });
      syncBuyOnceLabel();
    }

    function select(pack) {
      if (!pack) return;
      packs.forEach(function (p) { p.classList.toggle('is-selected', p === pack); });
      var radio = pack.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      var price = pack.getAttribute('data-price');
      var months = parseInt(pack.getAttribute('data-months'), 10) || 1;
      if (heroPrice) heroPrice.textContent = formatMoney(parseInt(price, 10) || 0);

      // Bump eligibility: strictly 1 bottle + one-time purchase only
      var isBumpEligible = (months === 1 && plan === 'one-time');
      if (bumpCard) {
        if (isBumpEligible) {
          bumpCard.removeAttribute('hidden');
        } else {
          bumpCard.setAttribute('hidden', '');
          if (bumpCheckbox) bumpCheckbox.checked = false;
        }
      }

      var finalPrice = parseInt(price, 10) || 0;
      if (isBumpEligible && bumpCheckbox && bumpCheckbox.checked) {
        var bumpCents = parseInt(bumpCard.getAttribute('data-bump-price'), 10) || 2995;
        finalPrice += bumpCents;
      }

      if (cta) {
        var baseText = cta.getAttribute('data-base-label') || 'ADD TO CART';
        cta.textContent = baseText;
      }

      // Sync the custom hidden input and Appstle's own radio for this pack.
      if (sellingPlanHidden) {
        var spId = (plan === 'subscribe' && pack) ? pack.getAttribute('data-selling-plan') : '';
        if (plan === 'subscribe' && !spId) {
          /* Never carry a previous pack's selling-plan ID into an unplanned variant. */
          plan = 'one-time';
          if (subscribeCheckbox) subscribeCheckbox.checked = false;
          updatePrices(false);
          return;
        }
        if (spId) {
          sellingPlanHidden.value = spId;
          sellingPlanHidden.disabled = false;
        } else {
          sellingPlanHidden.value = '';
          sellingPlanHidden.disabled = true;
        }
      }
      syncAppstleWidget(pack, plan === 'subscribe');
      syncBuyOnceLabel();
    }

    if (cta && !cta.getAttribute('data-base-label')) {
      cta.setAttribute('data-base-label', cta.textContent.replace(/\s*·.*$/, '').replace(/→$/, '').trim());
    }

    packs.forEach(function (p) {
      var radio = p.querySelector('input[type="radio"]');
      if (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) select(p);
        });
      }
      p.addEventListener('click', function (e) {
        if (e.target.tagName !== 'BUTTON') {
          select(p);
        }
      });
    });

    /* Pack card buttons submit with the chosen pack */
    form.querySelectorAll('[data-pack-select]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-pack-select');
        var r = form.querySelector('input[name="id"][value="' + val + '"]');
        if (r) {
          r.checked = true;
          var card = r.closest('[data-uf-pack]');
          if (card) select(card);
        }
      });
    });

    function syncAppstleWidget(pack, isSubscribe) {
      // Appstle can inject MORE THAN ONE .appstle_sub_widget, and the first one in
      // the form may hold no selling_plan radios at all. querySelector returned that
      // empty widget, so this function silently did nothing and the form submitted a
      // CONFLICTING pair of selling_plan values: the theme's hidden input carrying the
      // subscription plan, plus Appstle's stale one-time radio carrying "". Shopify's
      // cart resolves that pair non-deterministically - measured on the live store as
      // either a one-time line at the full price ($119.70 for the 6-bottle pack) or
      // two lines totalling $215.46. Target the widget that actually holds the radios
      // so both values agree; identical duplicates resolve to the single correct line.
      var radio = document.querySelector('.appstle_sub_widget input[type="radio"][name="selling_plan"]');
      if (!radio) return;
      var widget = radio.closest('.appstle_sub_widget');
      if (!widget) return;
      var targetValue = isSubscribe && pack ? pack.getAttribute('data-selling-plan') : '';
      var radios = widget.querySelectorAll('input[type="radio"][name="selling_plan"]');
      var targetRadio = Array.prototype.find.call(radios, function (input) { return input.value === targetValue; });
      if (targetRadio && !targetRadio.checked) {
        targetRadio.checked = true;
        targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Cache original HTML, base price and shipping note for real-time recalculations
    packs.forEach(function (p) {
      var priceEl = p.querySelector('.uf-pack-price');
      var totalEl = p.querySelector('.uf-pack-total');
      var perDayEl = p.querySelector('.uf-pack-per-day');
      var shipEl = p.querySelector('[data-shipping-note]');
      if (priceEl && !priceEl.getAttribute('data-original-html')) {
        priceEl.setAttribute('data-original-html', priceEl.innerHTML);
      }
      if (totalEl && !totalEl.getAttribute('data-original-html')) {
        totalEl.setAttribute('data-original-html', totalEl.innerHTML);
      }
      if (perDayEl && !perDayEl.getAttribute('data-original-html')) {
        perDayEl.setAttribute('data-original-html', perDayEl.innerHTML);
      }
      if (shipEl && !shipEl.getAttribute('data-original-html')) {
        shipEl.setAttribute('data-original-html', shipEl.innerHTML);
      }
      var basePrice = parseInt(p.getAttribute('data-base-price'), 10) || parseInt(p.getAttribute('data-price'), 10) || 0;
      if (!p.getAttribute('data-base-price')) {
        p.setAttribute('data-base-price', basePrice);
      }
    });

    function formatMoney(cents) {
      var currency = document.documentElement.getAttribute('data-currency');
      if (!currency) return String(cents);
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    }

    function updatePrices(isSubscribe) {
      packs.forEach(function (p) {
        var baseTotal = parseInt(p.getAttribute('data-base-price'), 10) || parseInt(p.getAttribute('data-price'), 10) || 0;
        var months = parseInt(p.getAttribute('data-months'), 10) || 1;
        
        // Use the exact selling-plan allocation cents carried by the pack card.
        var rawSubPrice = parseInt(p.getAttribute('data-subscription-price'), 10) || 0;
        var subscriptionTotal = rawSubPrice || baseTotal;

        var currentTotal = isSubscribe ? subscriptionTotal : baseTotal;
        p.setAttribute('data-price', currentTotal);

        var perBottleEl = p.querySelector('[data-per-bottle-price]') || p.querySelector('.uf-pack-hero-price');
        var totalNoteEl = p.querySelector('[data-total-note]') || p.querySelector('[data-ship-note]') || p.querySelector('.uf-pack-calc-note');

        var currentPerBottle = Math.round(currentTotal / months);
        var basePerBottle = Math.round(baseTotal / months);
        /* Subscribers have a subscription-only free-shipping profile; one-time single
           bottles remain below the shop's $60 free-shipping threshold. Shopify charges
           the converted equivalent of the $4.95 rate in local-currency markets and
           Liquid exposes no FX rate, so only USD (approved amount) and GBP (the
           client's manual 1:1 market) can print an exact figure. */
        var ufCurrency = document.documentElement.getAttribute('data-currency') || 'USD';
        var oneTimeShipText = ufCurrency === 'USD' ? '+$4.95 shipping'
          : (ufCurrency === 'GBP' ? '+£4.95 shipping' : '+ shipping at checkout');
        var shipText = (months === 1 && !isSubscribe) ? oneTimeShipText : 'Free shipping';

        if (perBottleEl) {
          perBottleEl.innerHTML = formatMoney(currentPerBottle) + '<span class="uf-per-unit">/bottle</span>';
        }
        if (totalNoteEl) {
          /* Same two-part structure the Liquid renders: the total line and the
             shipping note live in separate spans so each breakpoint can place
             them independently. Writing one flat string here would flatten that
             layout on the first subscription toggle. */
          var totalLine = '<span class="uf-pack-total-line">' + formatMoney(currentTotal) + ' total';
          if (isSubscribe) {
            totalLine += ' <s>' + formatMoney(baseTotal) + '</s>';
          }
          totalLine += '</span>';
          var shipNote = '<span class="uf-pack-ship-note"><span class="uf-ship-sep" aria-hidden="true">&bull;</span> ' + shipText + '</span>';
          totalNoteEl.innerHTML = totalLine + shipNote;
        }
      });

      var selectedPack = form.querySelector('[data-uf-pack].is-selected') || packs[0];
      if (selectedPack) select(selectedPack);
    }

    if (subscribeCheckbox) {
      subscribeCheckbox.addEventListener('change', function () {
        var selectedPack = form.querySelector('[data-uf-pack].is-selected') || packs[0];
        var isSub = subscribeCheckbox.checked;
        if (isSub && selectedPack && !selectedPack.getAttribute('data-selling-plan') && !selectedPack.getAttribute('data-subscription-price')) {
          subscribeCheckbox.checked = false;
          isSub = false;
        }
        plan = isSub ? 'subscribe' : 'one-time';
        if (ufNote) ufNote.textContent = '';
        updatePrices(isSub);
        select(selectedPack);
      });
    }

    var initialPack = form.querySelector('[data-uf-pack].is-selected') || packs[0];
    var isInitiallySub = !!(subscribeCheckbox && subscribeCheckbox.checked);
    plan = isInitiallySub ? 'subscribe' : 'one-time';
    updatePrices(isInitiallySub);

    // Appstle injects its selling-plan radios ASYNCHRONOUSLY, usually after this
    // script's init has already run, so the select() above calls syncAppstleWidget
    // before any radio exists and the sync is a silent no-op. The form then submits
    // the theme's hidden plan alongside Appstle's stale one-time radio - a
    // conflicting pair that Shopify's cart resolves unpredictably (measured: the
    // correct subscription line, a one-time line at the full price, or two lines
    // totalling ~2x). Re-run the sync as soon as the radios appear.
    (function resyncWhenAppstleReady() {
      var settled = false;
      function tryResync() {
        if (settled) return true;
        if (!document.querySelector('.appstle_sub_widget input[type="radio"][name="selling_plan"]')) return false;
        settled = true;
        var p = form.querySelector('[data-uf-pack].is-selected') || packs[0];
        if (p) syncAppstleWidget(p, plan === 'subscribe');
        return true;
      }
      if (tryResync()) return;
      var obs = new MutationObserver(function () { if (tryResync()) obs.disconnect(); });
      obs.observe(form, { childList: true, subtree: true });
      setTimeout(function () { tryResync(); obs.disconnect(); }, 12000);
    })();

    /* ---- AJAX add-to-cart with robust error handling & Auto-Cart-Clear ---- */
    var lastClickedBtn = null;
    form.querySelectorAll('[data-pack-select], button[type="submit"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        lastClickedBtn = btn;
      });
    });

    var checkoutPending = false;
    form.addEventListener('submit', function (e) {
      // Other submit controls or scripts can submit while the first request is pending.
      if (checkoutPending) { e.preventDefault(); return; }
      var radio = form.querySelector('input[name="id"]:checked');
      if (!radio || !window.Shopify) return; // allow native submit if no radio or not shopify

      e.preventDefault();
      var activeBtn = lastClickedBtn || cta;
      var originalBtnText = activeBtn ? activeBtn.textContent : '';
      if (activeBtn) { activeBtn.disabled = true; activeBtn.textContent = 'Processing...'; }

      var params = new URLSearchParams();
      params.append('id', radio.value);
      params.append('quantity', '1');

      // Appstle / Shopify Selling Plan Integration
      if (plan === 'subscribe') {
        var spVal = null;
        if (sellingPlanHidden && !sellingPlanHidden.disabled && sellingPlanHidden.value) {
          spVal = sellingPlanHidden.value;
        } else {
          var appstleSp = form.querySelector('input[name="selling_plan"]:checked, select[name="selling_plan"], [name="selling_plan"]');
          if (appstleSp && appstleSp.value) {
            spVal = appstleSp.value;
          }
        }
        if (spVal) {
          params.append('selling_plan', spVal);
        } else {
          if (activeBtn) { activeBtn.disabled = false; activeBtn.textContent = originalBtnText; }
          if (ufNote) ufNote.textContent = 'Subscription is temporarily unavailable. Please choose one-time purchase.';
          return;
        }
      }

      // Check for pre-checkout order bump
      var bumpCard = form.querySelector('[data-uf-order-bump]');
      var bumpCheckbox = form.querySelector('[data-uf-bump-checkbox]');
      var hasBump = bumpCheckbox && bumpCheckbox.checked && bumpCard && !bumpCard.hasAttribute('hidden');
      var bumpVariantId = (bumpCard && bumpCard.getAttribute('data-bump-variant-id')) || form.getAttribute('data-bump-variant-id') || '59096210571612';

      checkoutPending = true;
      // Clear cart first so accidental duplicate items are always removed
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' }
      }).then(function (response) {
        // Never add to an uncleared cart: stale items could change the checkout total.
        if (!response.ok) throw new Error('Unable to prepare your cart. Please try again.');
        return fetch((form.action || '/cart/add') + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          },
          body: params.toString()
        });
      }).then(function (r) {
        if (!r.ok) {
          return r.json().then(function (err) { throw err; });
        }
        return r.json();
      }).then(function () {
        if (hasBump) {
          var bumpParams = new URLSearchParams();
          bumpParams.append('id', bumpVariantId);
          bumpParams.append('quantity', '1');
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            },
            body: bumpParams.toString()
          }).then(function (r) {
            if (!r.ok) {
              return r.json().then(function (err) { throw err; });
            }
            return r.json();
          });
        }
        return null;
      }).then(function () {
        window.location.href = '/checkout';
      }).catch(function (err) {
        checkoutPending = false;
        if (activeBtn) { activeBtn.disabled = false; activeBtn.textContent = originalBtnText; }
        var message = (err && (err.description || err.message)) || '';
        if (message) {
          alert(message);
        } else {
          // A raw submit can duplicate a partially successful add and bypass plan selection.
          alert('Unable to update your cart. Please try again.');
        }
      });
    });
  });

  /* ---- In-Gallery Customer Review Slider ---- */
  var reviewSlider = document.querySelector('[data-uf-review-slider]');
  if (reviewSlider) {
    var slides = reviewSlider.querySelectorAll('[data-slide]');
    var dots = reviewSlider.querySelectorAll('[data-dot]');
    var curSlide = 0;
    var autoTimer = null;
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goToSlide(n) {
      var next = (n + slides.length) % slides.length;
      if (next === curSlide) return;
      curSlide = next;
      slides.forEach(function (s, i) {
        s.style.display = i === curSlide ? 'flex' : 'none';
        s.classList.toggle('is-active', i === curSlide);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === curSlide);
      });
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function (e) {
        e.preventDefault();
        goToSlide(i);
        resetAuto();
      });
    });

    /* The rotation only matters while the slider is on screen. Off-screen it was
       still toggling display every 5s, which invalidates layout for a component
       nobody is looking at - and layout work scheduled by a timer can land in the
       same frame as a shopper's tap. */
    var sliderInView = false;

    function resetAuto() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
      if (prefersReduced || document.hidden || !sliderInView) return;
      autoTimer = setInterval(function () { goToSlide(curSlide + 1); }, 5000);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (autoTimer) clearInterval(autoTimer);
      } else {
        resetAuto();
      }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sliderInView = entry.isIntersecting;
          resetAuto();
        });
      }, { rootMargin: '120px' }).observe(reviewSlider);
    } else {
      sliderInView = true;
      resetAuto();
    }
  }

  /* ---- Science Section: Animated Progress Bars & Count-Up ---- */
  var scienceSection = document.querySelector('[data-uf-science]');
  if (scienceSection && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var stats = scienceSection.querySelectorAll('[data-target]');
          stats.forEach(function (stat) {
            var target = parseInt(stat.getAttribute('data-target'), 10) || 0;
            var bar = stat.querySelector('.pm-science__bar-fill');
            var num = stat.querySelector('[data-count]');
            if (bar) {
              requestAnimationFrame(function () {
                bar.style.width = target + '%';
              });
            }
            if (num) {
              var dur = 2400;
              var startTime = null;
              function step(timestamp) {
                if (!startTime) startTime = timestamp;
                var progress = Math.min((timestamp - startTime) / dur, 1);
                // Ease-out cubic: matches CSS cubic-bezier(0.16, 1, 0.3, 1)
                var eased = 1 - Math.pow(1 - progress, 3);
                var val = Math.round(eased * target);
                num.textContent = val + '%';
                if (progress < 1) {
                  requestAnimationFrame(step);
                } else {
                  num.textContent = target + '%';
                }
              }
              requestAnimationFrame(step);
            }
          });
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    obs.observe(scienceSection);
  }

  /* ---- Comparison Tab Switcher ---- */
  var compareNav = document.querySelector('[data-uf-compare-nav]');
  var compareCard = document.querySelector('[data-uf-compare-card]');
  if (compareNav && compareCard) {
    var tabData = {
      deodorants: {
        icon: '🧴',
        badge: 'Deodorants',
        sub: 'Surface-level band-aid',
        items: [
          'Only masks underarm odor',
          "Doesn't work on intimate areas",
          'Contains aluminum & parabens',
          'Causes irritation, rash & stains',
          'Needs constant reapplying'
        ]
      },
      washes: {
        icon: '🧼',
        badge: 'Feminine Washes',
        sub: 'Disrupts delicate pH balance',
        items: [
          'Only cleans the outer surface temporarily',
          'Disrupts natural intimate flora & pH',
          'Can cause dryness, burning & irritation',
          'Odor returns within a few hours',
          'Does nothing for breath or full-body sweat'
        ]
      },
      probiotics: {
        icon: '💊',
        badge: 'Probiotics',
        sub: 'Incomplete digestive approach',
        items: [
          'Slow to colonize gut microbiome',
          'Does not directly bind volatile sulfur compounds',
          'Ineffective against active underarm odor',
          'Results vary wildly between individuals',
          'High monthly recurring cost with minimal odor relief'
        ]
      }
    };

    compareNav.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tabKey = btn.getAttribute('data-compare-tab');
        var data = tabData[tabKey];
        if (!data) return;

        compareNav.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        var iconEl = compareCard.querySelector('.card-top-icon');
        var badgeEl = compareCard.querySelector('.card-badge');
        var subEl = compareCard.querySelector('.card-subtitle');
        var listEl = compareCard.querySelector('.card-list');

        if (iconEl) iconEl.textContent = data.icon;
        if (badgeEl) badgeEl.textContent = data.badge;
        if (subEl) subEl.textContent = data.sub;
        if (listEl) {
          // Build nodes instead of parsing HTML so future merchant-supplied copy cannot
          // become executable markup if this data source is made configurable.
          // Clear + append rather than replaceChildren(): that method is newer than this
          // file's ES5 baseline and would throw on older Safari/Chromium.
          while (listEl.firstChild) listEl.removeChild(listEl.firstChild);
          data.items.forEach(function (item) {
            var row = document.createElement('li');
            var mark = document.createElement('span');
            mark.style.color = '#dc2626';
            mark.style.fontWeight = '700';
            mark.textContent = '✗';
            row.appendChild(mark);
            row.appendChild(document.createTextNode(' ' + item));
            listEl.appendChild(row);
          });
        }
      });
    });
  }

  /* ---- Universal Bulletproof Video Autoplay Engine ---- */
  var allVideos = document.querySelectorAll('video');
  allVideos.forEach(function (v) {
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.removeAttribute('loading');
  });

  function playMutedVideo(v) {
    if (!v || v.tagName !== 'VIDEO') return;
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    var p = v.play();
    if (p !== undefined) {
      p.catch(function () {});
    }
  }

  // #32 - HLS. Shopify's m3u8 master advertises the full ladder (SD-480p
  // ~1.29 Mbps up to HD-1080p ~3.72) and the player picks per bandwidth, so a
  // phone stops being served the 1080p rendition for a 279px card. Safari and
  // iOS play m3u8 natively and need nothing here. Chrome and Firefox do not, so
  // for them we attach hls.js - but ONLY at the moment the observer above
  // actually promotes a card to play(), and only once per page, so the library
  // is never part of initial page weight. The mp4 <source> stays in the markup
  // as the universal fallback, so if hls.js fails to load the card still plays.
  // Deliberately NOT attached here. Hls must not join initial page weight, so
  // the attach below is driven by the IntersectionObserver promoting a card to
  // play() (see the isIntersecting branch). The mp4 <source> in the markup is
  // what plays right up until that moment.
  var ufHlsScriptPromise = null;
  var nativeHls = function () {
    var v = document.createElement('video');
    return !!(v.canPlayType && v.canPlayType('application/vnd.apple.mpegURL'));
  };
  var loadHlsJs = function (ufHlsJsUrl) {
    if (!ufHlsJsUrl) return Promise.reject(new Error('no hls.js url'));
    if (window.Hls) return Promise.resolve(window.Hls);
    if (ufHlsScriptPromise) return ufHlsScriptPromise;
    ufHlsScriptPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      /* The URL is injected by the caller (snippets/unfunk-video-card.liquid
         passes it via data-uf-hls-js) because a .js asset is NOT rendered by
         Liquid, so an {{ asset_url }} filter in here would ship literally.
         Two earlier versions of this loader were wrong and both failed
         silently rather than loudly:
           - cdn.shopify.com/vendor/hls.min.js 404s to an HTML page, so onload
             fired, window.Hls stayed undefined, and every non-Safari browser
             quietly fell back to the 1080p mp4.
           - cdn.jsdelivr.net worked, but handed a third party a request on the
             critical video path and broke wherever that CDN was blocked.
         Still lazy: this runs only when the IntersectionObserver first promotes
         a card to play(), so the 405 KB never joins initial page weight. */
      s.src = ufHlsJsUrl;
      s.async = true;
      s.crossOrigin = 'anonymous';
      s.onload = function () {
        if (window.Hls) resolve(window.Hls); else reject(new Error('Hls global missing'));
      };
      s.onerror = function () { reject(new Error('hls.js failed to load')); };
      document.head.appendChild(s);
    });
    return ufHlsScriptPromise;
  };
  var attachHls = function (v) {
    var m3u8 = v.getAttribute('data-uf-hls');
    var hlsJs = v.getAttribute('data-uf-hls-js');
    if (!m3u8 || v.dataset.ufHlsAttached) return;
    if (nativeHls()) return; // Safari/iOS: the <source> already works
    if (v.canPlayType && v.canPlayType('application/vnd.apple.mpegURL')) return;
    v.dataset.ufHlsAttached = '1';
    loadHlsJs(hlsJs).then(function (Hls) {
      if (!Hls.isSupported()) return;
      var hls = new Hls({
        enableWorker: true,
        lowLatencyMode: false,
        /* The manifest advertises up to HD-1080p (~3.72 Mbps) and plain ABR
           climbs straight to it on a fast connection - measured live at 12.62 MB
           of 1080p segments, the very cost this change set out to remove, even
           though the card renders at only 279 CSS px. Capping ABR to the
           player's own size makes the 1080p rung ineligible and leaves the
           480p one, which is still ~2x the device pixels. Verified to select
           SD-480p at a 390px viewport. */
        capLevelToPlayerSize: true,
        capLevelOnFPSDrop: true
      });
      hls.loadSource(m3u8);
      hls.attachMedia(v);
      /* The observer already called v.play() before hls.js attached, and
         attachMedia swaps the element's source to a MediaSource blob - which
         resets playback to currentTime 0. The card therefore has to be told to
         resume AFTER the manifest parses, or it sits buffered but permanently
         PAUSED (observed 2026-09-30), i.e. silently dead.

         The observer marks intent itself, because at attach time the element is
         ALWAYS paused (that is the whole point of attaching on first play), so
         testing v.paused here could never distinguish "should play" from
         "user deliberately paused it". */
      hls.on(Hls.Events.MANIFEST_PARSED, function () {
        if (v.dataset.ufShouldPlay === '1' && v.muted && v.paused) {
          v.play().catch(function () {});
        }
      });
      // mp4 <source> stays as the guaranteed fallback if HLS errors out
      hls.on(Hls.Events.ERROR, function (e, data) {
        if (data && data.fatal) hls.destroy();
      });
    }).catch(function () {
      // leave the mp4 <source> in charge; nothing else to do
      delete v.dataset.ufHlsAttached;
    });
  };

  // Eagerly try to play all background autoplay videos
  document.querySelectorAll('video[autoplay]').forEach(playMutedVideo);

  // When any video buffers enough data, play immediately
  document.querySelectorAll('video[autoplay]').forEach(function (v) {
    v.addEventListener('canplay', function () {
      if (v.paused && v.muted) {
        v.play().catch(function () {});
      }
    });
    v.addEventListener('loadeddata', function () {
      if (v.paused && v.muted) {
        v.play().catch(function () {});
      }
    });
  });

  // IntersectionObserver: buffer and play 250px before entering viewport
  if ('IntersectionObserver' in window) {
    /* #33 - ROOT THE CAROUSEL AT ITS OWN TRACK. One observer cannot serve both
       cases, so there are two: `vObserver` is viewport-rooted and keeps
       handling the ordinary full-width videos (autoplay backgrounds, the
       use-steps / how-works / real-results blocks). `trackObserver` is rooted
       at the horizontally-scrolling `[data-uf-video-track]`.

       Why this was needed: the hero cards live in an overflow-clipped track
       (scrollWidth 1141 vs clientWidth 358 on a 390px viewport). The browser
       clips an IntersectionObserver target against every ancestor clip rect up
       to the root, so with the root at the viewport the 3rd and 4th cards
       (x=590 / 878, past the right edge) computed an EMPTY intersection rect
       and isIntersecting never became true - they sat at readyState 0 forever
       and could never play, on any mobile viewport. Rooting at the track makes
       "visible" mean "visible inside the scroller", which is what the reader
       actually sees after a swipe.

       rootMargin stays 250px so a card starts buffering slightly before it
       scrolls in, and preload="none" is untouched, so a card that is never
       scrolled to still fetches nothing. No `autoplay` is reintroduced here or
       in the markup: the whole 34 MB saving depends on it staying absent. */
    var vObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (v.tagName === 'VIDEO') {
          if (entry.isIntersecting) {
            // HLS attach happens HERE, on genuine play intent - not at load.
            if (typeof attachHls === 'function') attachHls(v);
            // Record the intent BEFORE play(): attachHls swaps the source to a
            // MediaSource blob, which resets currentTime to 0 and pauses the
            // element, so the resume-after-MANIFEST_PARSED handler in attachHls
            // has no other way to know this card was meant to be playing.
            v.dataset.ufShouldPlay = '1';
            if (v.muted && v.paused) {
              v.play().catch(function () {});
            }
          } else {
            // Only pause if it was actively playing to conserve CPU; never block initial startup
            if (!v.paused && v.currentTime > 0.2) {
              v.pause();
            }
          }
        }
      });
    }, { rootMargin: '250px 0px', threshold: 0.05 });

    /* #30 - the hero library videos are lazy: snippets/unfunk-video-card.liquid
       no longer emits `autoplay` and sets preload="none", so they are NOT matched
       by `video[autoplay]`. Observing them here is what turns a not-yet-fetched
       element into a playing one as it approaches the viewport - and, on the way
       out, pauses it (below). Deliberately NOT added to the eager pass above nor
       to the first-gesture fallback below: either would start all four at once
       and undo the 34.08 MB saving. */
    /* #34 - DUAL GATE. The track-rooted observer alone was a regression: it
       answers "is this card inside the horizontal scroller?" and says nothing
       about whether the carousel is near the VIEWPORT vertically. Measured on
       production 2026-09-30 at 1280x720, scrollY 0, with the whole carousel
       at y=1542: three of four cards reported isIntersecting, got
       ufShouldPlay=1 and pulled 18.1 MB of 1080p segments before the user
       scrolled at all - worse than the 34 MB bug it replaced, because it fired
       on every page load for every visitor.

       A card may now start only when BOTH are true:
         1. horizontally inside the track (trackObserver, #33) - without this,
            cards 3-4 can never load, which is what #33 fixed; and
         2. the carousel TRACK is within the viewport's vertical neighbourhood
            (measured directly from the track rect - see trackInView).
       Losing either clears ufShouldPlay and pauses, so a card that scrolls out
       vertically cannot be resurrected by a late MANIFEST_PARSED. Reverting to
       viewport-only would re-break cards 3-4, so the gate is AND, not OR. */
    var heroCards = document.querySelectorAll('.uf-hero-video-card--library video');
    var heroTrack = document.querySelector('[data-uf-video-track]');
    var inTrack = new WeakMap();

    // Vertical visibility is measured directly from the CAROUSEL TRACK's rect at
    // sync time, NOT from a second observer. Two independent observers latch
    // inconsistently: the track-rooted one only re-fires on HORIZONTAL change,
    // so scrolling the page down never re-runs it, and whichever callback runs
    // first can see the other side as still-unset and clear the flag for good.
    //
    // The TRACK is the subject, deliberately not its ancestor <section>: #uf-hero
    // begins at y=0 and is ~1741px tall, so it intersects the viewport at every
    // scroll position and would open the gate with the carousel still 1500px
    // below the fold - which is the regression this gate exists to prevent.
    var trackInView = function () {
      if (!heroTrack) return true;
      var r = heroTrack.getBoundingClientRect();
      return r.top < (window.innerHeight + 250) && r.bottom > -250;
    };

    var syncHeroCard = function (v) {
      var h = inTrack.get(v) === true;
      var s = trackInView();
      if (h && s) {
        if (typeof attachHls === 'function') attachHls(v);
        // intent flag BEFORE play(): attachHls swaps the source to a
        // MediaSource blob which resets currentTime, so the resume handler
        // has no other way to know the card was meant to be playing.
        v.dataset.ufShouldPlay = '1';
        if (v.muted && v.paused) {
          v.play().catch(function () {});
        }
      } else {
        // Clear the flag, not just pause - otherwise MANIFEST_PARSED fires
        // later and restarts a card that is now off screen.
        delete v.dataset.ufShouldPlay;
        if (!v.paused && v.currentTime > 0.2) {
          v.pause();
        }
      }
    };

    if (heroTrack && heroCards.length) {
      var trackObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target.tagName !== 'VIDEO') return;
          inTrack.set(entry.target, entry.isIntersecting);
          syncHeroCard(entry.target);
        });
      }, { root: heroTrack, rootMargin: '250px 0px', threshold: 0.05 });

      Array.prototype.forEach.call(heroCards, function (v) {
        if (v.tagName === 'VIDEO') trackObserver.observe(v);
      });

      /* The rect check above is only evaluated when something wakes syncHeroCard,
         and a track-rooted observer never fires on VERTICAL scroll. Without this
         the carousel can be scrolled into view and nothing starts, which is
         exactly what testing caught on 2026-09-30. rAF-throttled, and it early-
         exits when no card currently wants to play, so it costs nothing on a
         normal page. */
      var heroSyncQueued = false;
      var requestHeroSync = function () {
        if (heroSyncQueued) return;
        heroSyncQueued = true;
        window.requestAnimationFrame(function () {
          heroSyncQueued = false;
          Array.prototype.forEach.call(heroCards, syncHeroCard);
        });
      };
      window.addEventListener('scroll', requestHeroSync, { passive: true });
      window.addEventListener('resize', requestHeroSync, { passive: true });
    }

    Array.prototype.forEach.call(document.querySelectorAll('video[autoplay], .pm-use-steps__media, .pm-how-works__video, .pm-real-results__video'), function (v) {
      if (v.tagName === 'VIDEO') {
        vObserver.observe(v);
      }
    });
    /* Hero cards are registered with trackObserver inside the block above. If
       the track is missing entirely, fall back to the viewport observer so the
       cards are never left unobserved. */
    if (!heroTrack) {
      Array.prototype.forEach.call(heroCards, function (v) {
        if (v.tagName === 'VIDEO') vObserver.observe(v);
      });
    }
  }

  // Global user gesture fallback to immediately start any stubborn paused videos on first interaction
  var gestureUnlocked = false;
  var onUserGesture = function () {
    if (gestureUnlocked) return;
    gestureUnlocked = true;
    document.querySelectorAll('video[autoplay]').forEach(function (v) {
      if (v.paused && v.muted) {
        v.play().catch(function () {});
      }
    });
    ['touchstart', 'touchend', 'scroll', 'click', 'keydown', 'wheel'].forEach(function (e) {
      window.removeEventListener(e, onUserGesture);
    });
  };
  ['touchstart', 'touchend', 'scroll', 'click', 'keydown', 'wheel'].forEach(function (e) {
    window.addEventListener(e, onUserGesture, { passive: true });
  });

  /* ---- UGC Video Interactive Player ----
     One behaviour for every click-to-hear video card, used by the "Real Women Real
     Results" cards and the hero video cards:

       muted + autoplaying  -> click 1: enable sound (every other card is re-muted, not paused)
       audible + playing    -> click 2: pause, stays audible
       audible + paused     -> click 3: play

     Cards autoplay muted as they scroll into view via the shared video engine above. */
  var initUgcSoundCards = function (container, cardSelector, toggleSelector) {
    var ugcCards = Array.prototype.slice.call(container.querySelectorAll(cardSelector));
    if (!ugcCards.length) return;

    var syncUgcCard = function (card) {
      var v = card.querySelector('video');
      var btn = card.querySelector(toggleSelector);
      if (!v) return;
      var audible = !v.muted;
      var paused = v.paused;
      card.classList.toggle('is-unmuted', audible);
      card.classList.toggle('is-paused', paused);
      if (btn) {
        btn.setAttribute('aria-pressed', audible ? 'true' : 'false');
        btn.setAttribute('aria-label', audible ? (paused ? 'Play video' : 'Pause video') : 'Enable sound');
      }
    };

    ugcCards.forEach(function (card) {
      var v = card.querySelector('video');
      var btn = card.querySelector('[data-rr-toggle]');
      if (!v) return;

      var onToggle = function (e) {
        if (e) e.stopPropagation();
        if (v.muted) {
          // First click: this card gets sound, the others go silent but keep playing
          ugcCards.forEach(function (other) {
            if (other === card) return;
            var otherV = other.querySelector('video');
            if (!otherV) return;
            otherV.muted = true;
            syncUgcCard(other);
          });
          v.muted = false;
          v.volume = 1;
          var played = v.play();
          if (played && played.catch) {
            played.catch(function () {
              // Sound was refused: fall back to muted playback rather than a dead button
              v.muted = true;
              var retry = v.play();
              if (retry && retry.catch) retry.catch(function () {});
            });
          }
        } else if (v.paused) {
          var resumed = v.play();
          if (resumed && resumed.catch) resumed.catch(function () {});
        } else {
          v.pause();
        }
        syncUgcCard(card);
      };

      card.addEventListener('click', onToggle);
      if (btn) btn.addEventListener('click', onToggle);
      v.addEventListener('play', function () { syncUgcCard(card); });
      v.addEventListener('pause', function () { syncUgcCard(card); });
      v.addEventListener('volumechange', function () { syncUgcCard(card); });
      syncUgcCard(card);
    });
  };

  var realResults = document.querySelector('[data-uf-real-results]');
  if (realResults) initUgcSoundCards(realResults, '.pm-real-results__card', '[data-rr-toggle]');

  var heroVideoCards = document.querySelector('[data-uf-hero]');
  if (heroVideoCards) initUgcSoundCards(heroVideoCards, '.uf-hero-video-card--library', '[data-uf-video-toggle]');

  /* ---- Timeline ----
     The scroll-driven checkpoint logic that used to live here queried
     [data-timeline-item] and [data-timeline-line-fill], neither of which exists in
     sections/unfunk-timeline.liquid, so it returned on its first line every time and
     never ran. The rows already animate in through the shared .uf-reveal observer,
     and the spine is a static dashed ::before with no fill element to drive.
     Removed rather than left in place: dead code that looks like a working feature is
     how a real regression hides later. */

  /* ---- A/B arm: sticky CTA on/off, selected by URL parameter ----
     DEFAULT IS OFF. A bare URL shows NO sticky bar; the bar appears only when the
     URL explicitly asks for it. Inverted 2026-09-18 at the client's request —
     previously the root served the sticky arm and ?uf_ab=nosticky was the control,
     so every ordinary visitor got the bar whether they were in the test or not.

       ?uf_ab=sticky  (aliases: stickycta, on, 1, true, yes, show, visible) -> bar
       anything else, or no parameter at all                                -> no bar

     `ab` works as a shorter alias. The "off" spellings are not enumerated: with
     the default inverted, an unrecognised value cannot accidentally turn the bar
     ON, which is the failure that matters here. (?uf_ab=nosticky still resolves
     to off, so any already-circulating control links keep behaving as control.)

     The URL is the ONLY input. The arm is deliberately NOT persisted, so nobody
     can land on a stale variant and report "the sticky bar is missing". (An
     earlier version stored it in sessionStorage, which meant one visit suppressed
     the bar on every later bare URL in that tab.) The stale key is cleared below.

     The arm is mirrored onto <html> as data-uf-ab so the pixel / GTM can record
     which arm converted — it now reads 'nosticky' by default, so any reporting
     built on 'sticky' being the baseline needs its baseline re-stated. The bar
     ships `visibility:hidden` + `inert`, so the off arm costs no scroll listener
     and cannot flash before this runs. */
  var UF_AB_STALE_KEY = 'uf_ab_sticky';
  var UF_AB_ON = ['sticky', 'stickycta', 'on', '1', 'true', 'yes', 'show', 'visible'];
  var ufAbSticky = false;
  var ufAbArm = 'nosticky';
  (function () {
    var raw = null;
    try {
      var params = new URLSearchParams(window.location.search);
      raw = params.get('uf_ab') || params.get('ab');
    } catch (e) { raw = null; }
    if (raw) {
      var norm = String(raw).toLowerCase().replace(/[^a-z0-9]/g, '');
      ufAbSticky = UF_AB_ON.indexOf(norm) !== -1;
      ufAbArm = ufAbSticky ? 'sticky' : 'nosticky';
    }
    try { window.sessionStorage.removeItem(UF_AB_STALE_KEY); } catch (e) { /* private mode */ }
    document.documentElement.setAttribute('data-uf-ab', ufAbArm);
    window.ufAb = { arm: ufAbArm, sticky: ufAbSticky };
  })();

  /* ---- 1:1 Reference Full-Width Bottom Sticky ATC Bar ---- */
  var stickyBar = document.getElementById('pmStickyAtc') || document.getElementById('ufStickyBar');
  /* The layout renders this bar on every template, but the purchase form only
     exists on the funnel ones. Point the button at the pack selection when it
     is there; fall back to the hero, and to a no-op on pages with neither, so
     the CTA is never a dead anchor. */
  if (stickyBar) {
    var stickyCta = stickyBar.querySelector('.pm-sticky-atc__btn');
    if (stickyCta && !document.getElementById('uf-buy')) {
      stickyCta.setAttribute('href', document.getElementById('uf-hero') ? '#uf-hero' : '#');
    }
  }
  if (stickyBar && ufAbSticky) {
    var stickyVisible = null;
    /* Show the bar once the section FOLLOWING the hero has cleared the viewport
       — that is "after the 2nd section", measured rather than guessed, so it
       survives sections being added or removed.

       Shopify wraps every section in a `.shopify-section`, so the hero's own
       wrapper is the element with siblings; #uf-hero itself has none. The
       previous version counted `.uf-section` elements instead, and the review
       strip does not carry that class (its root is `.uf-rstrip`), so the
       threshold silently landed one section too far down the page.

       Falls back to the 2nd `.uf-section`, then the 1st, on templates with no
       hero. */
    var ufHeroWrap = document.getElementById('uf-hero');
    ufHeroWrap = ufHeroWrap ? ufHeroWrap.closest('.shopify-section') : null;
    var ufThreshold = ufHeroWrap ? ufHeroWrap.nextElementSibling : null;
    if (!ufThreshold || !ufThreshold.getBoundingClientRect) {
      var ufSections = document.querySelectorAll('.uf-section');
      ufThreshold = ufSections.length > 1 ? ufSections[1] : ufSections[0];
    }
    var checkScroll = function () {
      if (!ufThreshold) return;
      var rect = ufThreshold.getBoundingClientRect();
      var shouldShow = rect.bottom < 0;
      if (shouldShow === stickyVisible) return;
      stickyVisible = shouldShow;
      if (shouldShow) {
        stickyBar.classList.add('is-visible');
        stickyBar.removeAttribute('aria-hidden');
        stickyBar.removeAttribute('inert');
      } else {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
        stickyBar.setAttribute('inert', '');
      }
    };
    var scheduleSticky = rafThrottle(checkScroll);
    window.addEventListener('scroll', scheduleSticky, { passive: true });
    window.addEventListener('resize', scheduleSticky, { passive: true });
    checkScroll();
  }

  /* ---- Personal Stories Carousel Slider Controller ---- */
  document.querySelectorAll('[data-uf-stories]').forEach(function (section) {
    var track = section.querySelector('[data-stories-track]');
    var cards = track ? track.querySelectorAll('.uf-story-card') : [];
    var prevBtn = section.querySelector('[data-stories-prev]');
    var nextBtn = section.querySelector('[data-stories-next]');
    var dots = section.querySelectorAll('[data-stories-dots] .uf-stories-dot');
    if (!track || !cards.length) return;

    var currentIndex = 0;
    var total = cards.length;

    function getTargetScroll(index) {
      if (index < 0) index = 0;
      if (index >= total) index = total - 1;
      var card = cards[index];
      if (!card) return 0;
      var isMobile = window.innerWidth < 768;
      if (isMobile) {
        return (card.offsetLeft - track.offsetLeft) - ((track.clientWidth - card.offsetWidth) / 2);
      } else {
        return card.offsetLeft - track.offsetLeft;
      }
    }

    function goToSlide(index) {
      if (index < 0) index = 0;
      if (index >= total) index = total - 1;
      currentIndex = index;

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });

      var targetScroll = getTargetScroll(currentIndex);
      track.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var nextIdx = currentIndex > 0 ? currentIndex - 1 : total - 1;
        goToSlide(nextIdx);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var nextIdx = currentIndex < total - 1 ? currentIndex + 1 : 0;
        goToSlide(nextIdx);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        var idx = parseInt(dot.getAttribute('data-dot'), 10) || 0;
        goToSlide(idx);
      });
    });

    // Sync active dot on scroll/swipe
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var currentScroll = track.scrollLeft;
        var minDiff = Infinity;
        var closestIdx = 0;
        var isMobile = window.innerWidth < 768;

        cards.forEach(function (card, idx) {
          var target = isMobile
            ? (card.offsetLeft - track.offsetLeft) - ((track.clientWidth - card.offsetWidth) / 2)
            : (card.offsetLeft - track.offsetLeft);
          var diff = Math.abs(currentScroll - target);
          if (diff < minDiff) {
            minDiff = diff;
            closestIdx = idx;
          }
        });

        if (closestIdx !== currentIndex) {
          currentIndex = closestIdx;
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === currentIndex);
          });
        }
      }, 50);
    }, { passive: true });
  });

  /* ---- UI/UX Pro Max: Tasteful Scroll Entry Animations ---- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var revealObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -50px 0px',
      threshold: 0.08
    });

    document.querySelectorAll('.uf-reveal, .uf-reveal-stagger').forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    document.querySelectorAll('.uf-reveal, .uf-reveal-stagger').forEach(function (el) {
      el.classList.add('is-revealed');
    });
  }

  /* ---- Urgency / Demand Banner (Animated Bar & Persistent Cached Timer) ---- */
  function initUrgencyBanner() {
    var banner = document.querySelector('[data-uf-urgency]');
    if (!banner) return;

    var bar = banner.querySelector('[data-uf-urgency-bar]');
    var timer = banner.querySelector('[data-uf-urgency-timer]');

    // 1. Smoothly animate progress bar from 0% on load
    if (bar) {
      var targetPercent = parseInt(bar.getAttribute('data-percent'), 10) || 89;
      bar.style.width = '0%';
      setTimeout(function () {
        bar.style.width = targetPercent + '%';
      }, 150);
    }

    // 2. Persistent Cached Countdown Timer
    if (timer) {
      var initialText = (timer.getAttribute('data-initial-timer') || timer.textContent || '14:01:30').trim();

      function parseTimeToSeconds(timeStr) {
        var clean = timeStr.replace(/[^0-9:]/g, '');
        var parts = clean.split(':').map(function (p) { return parseInt(p, 10) || 0; });
        if (parts.length === 3) {
          return parts[0] * 3600 + parts[1] * 60 + parts[2];
        } else if (parts.length === 2) {
          return parts[0] * 60 + parts[1];
        }
        return 50490; // Default: ~14h 01m 30s
      }

      function formatSeconds(totalSecs) {
        var h = Math.floor(totalSecs / 3600);
        var m = Math.floor((totalSecs % 3600) / 60);
        var s = totalSecs % 60;
        var hh = h < 10 ? '0' + h : '' + h;
        var mm = m < 10 ? '0' + m : '' + m;
        var ss = s < 10 ? '0' + s : '' + s;
        return hh + ':' + mm + ':' + ss;
      }

      var defaultDuration = parseTimeToSeconds(initialText);
      var STORAGE_KEY = 'unfunk_pdp_urgency_expiry';
      var now = Date.now();
      var expiry = null;

      try {
        var stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
          var parsed = parseInt(stored, 10);
          if (parsed && parsed > now) {
            expiry = parsed;
          }
        }
      } catch (e) {
        // localStorage unavailable (e.g. strict private mode)
      }

      // If no valid stored expiry or expired, set a new target
      if (!expiry) {
        expiry = now + (defaultDuration * 1000);
        try {
          localStorage.setItem(STORAGE_KEY, expiry.toString());
        } catch (e) {}
      }

      function updateTimer() {
        var currentNow = Date.now();
        var remainingMs = expiry - currentNow;

        if (remainingMs <= 0) {
          // Reset a continuous rolling window (e.g., 2 hours) so user never sees dead 00:00:00
          expiry = currentNow + (2 * 3600 * 1000);
          try {
            localStorage.setItem(STORAGE_KEY, expiry.toString());
          } catch (e) {}
          remainingMs = expiry - currentNow;
        }

        var remainingSeconds = Math.max(0, Math.floor(remainingMs / 1000));
        timer.textContent = formatSeconds(remainingSeconds);
      }

      updateTimer();

      /* The countdown only needs to tick while it can be seen. Running it forever
         cost a text write plus a layout invalidation every second, and a timer that
         fires during an interaction is exactly what the INP metric punishes. */
      var urgencyWrap = timer.closest('[data-uf-urgency]') || timer;
      var timerInterval = null;
      function startTimer() {
        if (timerInterval || document.hidden) return;
        timerInterval = setInterval(updateTimer, 1000);
      }
      function stopTimer() {
        if (!timerInterval) return;
        clearInterval(timerInterval);
        timerInterval = null;
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) startTimer();
            else stopTimer();
          });
        }, { rootMargin: '120px' }).observe(urgencyWrap);
      } else {
        startTimer();
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopTimer();
        else startTimer();
      });
    }
  }

  // Initialize Urgency Banner
  initUrgencyBanner();
})();

/* Hero UGC video carousel: arrow paging with disabled states.
   Progressive enhancement - without JS the track is still swipeable/scrollable. */
(function () {
  var root = document.querySelector('[data-uf-video-carousel]');
  if (!root) return;
  var track = root.querySelector('[data-uf-video-track]');
  var prev = root.querySelector('[data-uf-video-prev]');
  var next = root.querySelector('[data-uf-video-next]');
  if (!track) return;
  function step() {
    var card = track.firstElementChild;
    if (!card) return track.clientWidth;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || '8') || 8;
    return card.getBoundingClientRect().width + gap;
  }
  function measure() {
    var max = track.scrollWidth - track.clientWidth;
    root.classList.toggle('has-overflow', max > 2);
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
  }
  if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  track.addEventListener('scroll', measure, { passive: true });
  window.addEventListener('resize', measure);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  measure();
})();
